import { achievements } from '../data/achievements';

export class AchievementManager {
  static checkAchievements(gameData, playerStats) {
    const newAchievements = [];
    const unlockedAchievements = JSON.parse(localStorage.getItem('unlockedAchievements') || '[]');
    const unlockedIds = unlockedAchievements.map(a => a.id);

    for (const achievement of achievements) {
      if (unlockedIds.includes(achievement.id)) continue;

      if (this.isAchievementUnlocked(achievement, gameData, playerStats)) {
        const achievementData = {
          ...achievement,
          unlockedAt: Date.now()
        };
        
        newAchievements.push(achievementData);
        unlockedAchievements.push(achievementData);
      }
    }

    if (newAchievements.length > 0) {
      localStorage.setItem('unlockedAchievements', JSON.stringify(unlockedAchievements));
    }

    return newAchievements;
  }

  static isAchievementUnlocked(achievement, gameData, playerStats) {
    switch (achievement.type) {
      case 'score':
        return gameData.score >= achievement.target;
      
      case 'accuracy':
        return gameData.accuracy >= achievement.target;
      
      case 'streak':
        return gameData.streak >= achievement.target;
      
      case 'games':
        return (playerStats.totalGames || 0) >= achievement.target;
      
      case 'perfect':
        return (playerStats.perfectMatches || 0) >= achievement.target;
      
      case 'speed':
        return (playerStats.fastAnswers || 0) >= achievement.target;
      
      case 'special':
        if (achievement.id === 'no_hints') {
          return (playerStats.gamesWithoutHints || 0) >= achievement.target;
        }
        break;
      
      case 'difficulty':
        if (achievement.id === 'hard_master') {
          return (playerStats.hardModeWins || 0) >= achievement.target;
        }
        break;
      
      case 'gamemode':
        if (achievement.id === 'time_master') {
          return (playerStats.timedModeWins || 0) >= achievement.target;
        }
        if (achievement.id === 'endless_warrior') {
          return (playerStats.endlessModeWins || 0) >= achievement.target;
        }
        break;
      
      default:
        return false;
    }
    
    return false;
  }

  static updatePlayerStats(gameData) {
    const currentStats = JSON.parse(localStorage.getItem('playerStats') || '{}');
    
    const updatedStats = {
      ...currentStats,
      totalGames: (currentStats.totalGames || 0) + 1,
      bestScore: Math.max(currentStats.bestScore || 0, gameData.score),
      bestAccuracy: Math.max(currentStats.bestAccuracy || 0, gameData.accuracy),
      bestStreak: Math.max(currentStats.bestStreak || 0, gameData.streak),
      totalScore: (currentStats.totalScore || 0) + gameData.score,
      perfectMatches: (currentStats.perfectMatches || 0) + (gameData.accuracy >= 99 ? 1 : 0),
      fastAnswers: (currentStats.fastAnswers || 0) + (gameData.wasQuickAnswer ? 1 : 0),
      gamesWithoutHints: (currentStats.gamesWithoutHints || 0) + (gameData.hintsUsed === 0 ? 1 : 0),
    };

    // Track difficulty-specific wins
    if (gameData.isWin) {
      if (gameData.difficulty === 'hard') {
        updatedStats.hardModeWins = (updatedStats.hardModeWins || 0) + 1;
      }
      
      if (gameData.gameMode === 'timed') {
        updatedStats.timedModeWins = (updatedStats.timedModeWins || 0) + 1;
      } else if (gameData.gameMode === 'endless') {
        updatedStats.endlessModeWins = (updatedStats.endlessModeWins || 0) + 1;
      }
    }

    localStorage.setItem('playerStats', JSON.stringify(updatedStats));
    return updatedStats;
  }

  static getPlayerLevel() {
    const unlockedAchievements = JSON.parse(localStorage.getItem('unlockedAchievements') || '[]');
    const totalXP = unlockedAchievements.reduce((sum, a) => sum + a.points, 0);
    
    // Calculate level based on XP (every 500 XP = 1 level)
    const level = Math.floor(totalXP / 500) + 1;
    const currentLevelXP = totalXP % 500;
    const nextLevelXP = 500;
    
    return {
      level,
      currentXP: totalXP,
      currentLevelXP,
      nextLevelXP,
      progress: (currentLevelXP / nextLevelXP) * 100
    };
  }
}